<script lang="ts" setup>
defineProps<{ ranking: Ranking, customRoute?: string, forDisplay?: boolean }>()
const localePath = useLocalePath()
</script>

<template>
  <UiListItem :to="customRoute ?? localePath(`/manage/rankings/${ranking.id}`)">
    <div class="w-14 h-14 shrink-0 flex items-start justify-center">
      <NuxtImg
        v-if="ranking.image"
        :src="ranking.image.replace('dartsspace.test', 'api.dartsspace.com')"
        :alt="`Ranking poster ${ranking.name}`"
        fit="contain"
        class="rounded-lg max-h-14 max-w-14 w-auto"
        width="100"
        height="100"
        placeholder
        quality="80"
        loading="lazy"
      />
      <UiAvatar
        v-else
        :fallback="ranking.name[0]"
      />
    </div>
    <UiListContent class="flex-1">
      <UiListTitle>
        {{ ranking.name }}
      </UiListTitle>
      <UiListSubtitle as="div">
        <UiBadge
          v-if="!forDisplay"
          variant="outline"
          :color="ranking.published ? 'green' : 'yellow'"
        >
          {{ ranking.published ? $t('Published') : $t('Unpublished') }}
        </UiBadge>
      </UiListSubtitle>
      <UiListSubtitle>
        <CommonDateTime
          v-if="ranking.created_at"
          :date="ranking.created_at"
        />
      </UiListSubtitle>
      <div class="flex flex-row gap-2 justify-end">
        <slot name="actions">
          <UiButton
            size="xs"
            icon="tabler:arrow-right"
            icon-placement="right"
          >
            {{ $t('Manage') }}
          </UiButton>
        </slot>
      </div>
    </UiListContent>
  </UiListItem>
</template>
